module.exports = __webpack_public_path__ + "static/media/home-gallery-image8.5ad0160c.png";